// extracted by mini-css-extract-plugin
export default {"checkbox_container":"Checkbox_checkbox_container__f0INn","checkbox":"Checkbox_checkbox__71xI9","highlightChecked":"Checkbox_highlightChecked__sVDnj"};